{% block swag_customerPrice_detail %}
    <sw-page class="vio-customer-price-detail">
        <template #smart-bar-actions>
            <mt-button
                @click="this.$router.push({ name: 'vio.customer.price.list' })"
            >
                {{ $tc('global.default.cancel') }}
            </mt-button>
            <sw-button-process
                :isLoading="isLoading"
                :processSuccess="processSuccess"
                variant="primary"
                @process-finish="saveFinish"
                @click="onClickSave"
            >
                {{ $tc('global.default.save') }}
            </sw-button-process>
        </template>

        <template #content>
            <sw-card-view>
                <mt-card
                    v-if="customerPrice"
                    :isLoading="isLoading"
                >
                    <mt-number-field
                        :label="$t('vio-customer-price.detail.quantityStartLabel')"
                        v-model="customerPrice.quantityStart"
                    ></mt-number-field>
                    <mt-number-field
                        :label="$t('vio-customer-price.detail.quantityEndLabel')"
                        :disabled="true"
                        v-model="customerPrice.quantityEnd"
                    ></mt-number-field>
                    <mt-number-field
                        :label="$t('vio-customer-price.detail.priceLabel')"
                        v-model="customerPrice.price"
                        type="number"
                    ></mt-number-field>
                    <mt-number-field
                        :label="$t('vio-customer-price.detail.discountLabel')"
                        v-model="customerPrice.discount"
                    ></mt-number-field>
                    <sw-entity-single-select
                        :label="$t('vio-customer-price.detail.assignProductLabel')"
                        entity="product"
                        v-model:value="customerPrice.productId"
                    >
                        <template
                            #selection-label-property="{ item }"
                        >
                            {{ item.translated.name }}
                            (
                            {{ item.productNumber }}
                            )
                        </template>

                        <template
                            #result-label-property="{ item }"
                        >
                            {{ item.translated.name }}
                            (
                            {{ item.productNumber }}
                            )
                        </template>
                    </sw-entity-single-select>
                    <sw-entity-single-select
                        :label="$t('vio-customer-price.detail.assignCustomerLabel')"
                        entity="customer"
                        v-model:value="customerPrice.customerId"
                    >
                        <template
                            #selection-label-property="{ item }"
                        >
                            {{ item.company }}
                            {{ item.firstName }}
                            {{ item.lastName }}
                            (
                            {{ item.customerNumber }}
                            )
                        </template>

                        <template
                            #result-label-property="{ item }"
                        >
                            {{ item.company }}
                            {{ item.firstName }}
                            {{ item.lastName }}
                            (
                            {{ item.customerNumber }}
                            )
                        </template>
                    </sw-entity-single-select>
                </mt-card>
                <!-- eslint-disable-next-line sw-deprecation-rules/no-twigjs-blocks -->
                <mt-card
                    v-if="customFieldSets.length > 0"
                    :title="$tc('sw-settings-custom-field.general.mainMenuItemGeneral')"
                    :is-loading="isLoading"
                >
                    <sw-custom-field-set-renderer
                        :entity="customerPrice"
                        :sets="customFieldSets"
                        v-model:value="customerPrice.customFields"
                    >
                </sw-custom-field-set-renderer>
                </mt-card>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}